import IcDeleteOutline from './IcDeleteOutline'

export default IcDeleteOutline
